import React, { useEffect } from "react";
import "./about.css";

import Mission from "../assets/images/mission.png";
import Vission from "../assets/images/vision.png";

import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);
  return (
    <>
      <div className="about-banner">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div
            className="about-content"
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            <div className="heading">
              <div className="heading-flex">
                <h2>About Us</h2>
                <p>
                  At Fidus, we’re passionate about unlocking potential through
                  the power of eTraining. Our focus extends beyond offering
                  eTraining solutions – we're dedicated to upskilling,
                  motivating, and transforming individuals. With flexible,
                  personalized, and cost-effective programs, we empower
                  individuals and organizations to thrive in the digital age.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-section">
        <div className="after-banner-circle"></div>
        <div className="about-section-content">
          <div className="container-fluid">
            <div className="row row1">
              <div className="col-lg-9">
                <div
                  className="heading"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <h2>Vision</h2>
                  <p>
                    At Fidus India, we aspire to create a world where access to
                    education and training transcends geographical boundaries,
                    reaching every corner where people seek knowledge and
                    transformation. Our vision is to ignite the spark of
                    potential within every individual and organization,
                    empowering them to soar to new heights of success and
                    achievement.
                  </p>
                </div>
              </div>
              <div className="col-lg-3">
                <div
                  className="vission-mission-img"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <img src={Vission} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-lg-3">
              <div
                  className="vission-mission-img"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <img src={Mission} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-lg-9">
                <div
                  className="heading"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <h2>Mission</h2>
                  <p>
                    Driven by our passion for integrating education with
                    technology, our mission is to redefine learning by making it
                    accessible and effective through modern eLearning solutions.
                    We are committed to empowering individuals by providing
                    practical tools and resources that adapt and improve the
                    learning experience in today's ever-changing world.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="why-choose-fidus">
        <div className="heading" data-aos="fade-up" data-aos-duration="1500">
          <h2>Why Choose Fidus</h2>
          <p>
            Fidus offers personalized learning solutions, transparent
            communication, a human-centric approach, and proven results to help
            you achieve your goals. We take the time to deeply understand your
            unique needs, craft customized programs, maintain open dialogue,
            leverage our expert team, and deliver tangible outcomes through our
            time-tested methods and successful track record.
          </p>
        </div>
        <div
          className="container-fluid"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="row">
            <div className="col-lg-3">
              <div className="feature one">
                <h4>
                  Proven <br /> Results
                </h4>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="feature two">
                <h4>
                  Human <br /> Touch
                </h4>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="feature three">
                <h4>
                  Tailored <br /> Solutions
                </h4>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="feature four">
                <h4>
                  Transparent <br /> Communication
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
